import * as React from 'react';
import { cn } from '@/lib/utils';

// Brand-tinted skeleton block. Pulses via opacity (impeccable says
// don't animate layout properties — opacity + transform only).

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {}

export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        'animate-[skeleton-pulse_1.6s_ease-in-out_infinite] rounded-md bg-muted/70',
        className,
      )}
      {...props}
    />
  );
}

interface SkeletonCardProps {
  className?: string;
}

export function SkeletonCard({ className }: SkeletonCardProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-3 rounded-xl border bg-card p-5',
        className,
      )}
    >
      <div className="flex items-start justify-between gap-2">
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-5 w-16 rounded-full" />
      </div>
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-3 w-40" />
      <div className="flex items-center justify-between pt-2">
        <Skeleton className="h-8 w-16" />
        <Skeleton className="h-3 w-12" />
      </div>
    </div>
  );
}
